import { Modal, type ModalProps } from "antd/es";
import React from "react";

import { cx } from "~/tools/class-variance";

const ModalWithChildren: React.FC<React.PropsWithChildren<ModalProps>> = Modal;

export interface ExpirationModalProps {
	headerText: string;
	daysLeftImage: string;
	bodyContent: React.ReactElement | number | string;
	visible: boolean;
	closable: boolean;
	cancelButton: boolean;
	applyForLicense: () => void;
	onCancel?: () => void;
}

export const ExpirationModal: React.FC<ExpirationModalProps> = ({
	headerText,
	daysLeftImage,
	bodyContent,
	visible,
	closable,
	cancelButton,
	applyForLicense,
	onCancel,
}) => (
	<ModalWithChildren
		cancelButtonProps={{ type: "ghost" }}
		cancelText="Keep using trial"
		centered={true}
		className={cx(
			"[&_.ant-modal-body]:px-10 [&_.ant-modal-body]:pt-10 [&_.ant-modal-body]:pb-0",
			"[&_.ant-modal-footer]:border-none [&_.ant-modal-footer]:px-10 [&_.ant-modal-footer]:pt-8 [&_.ant-modal-footer]:pb-10",
			"[&_.ant-modal-footer_button+button]:ml-5",
			[
				"[&_.ant-btn-ghost]:border-primary-600 [&_.ant-btn-ghost]:text-primary-600",
				cancelButton ? "[&_.ant-btn-ghost]:inline-block" : "[&_.ant-btn-ghost]:hidden",
			],
		)}
		closable={closable}
		keyboard={false}
		maskClosable={false}
		okText="Contact us"
		onCancel={onCancel}
		onOk={applyForLicense}
		visible={visible}
		width={800}
	>
		<div className="flex flex-row text-gray-800" data-testid="expirationModal__container">
			<div className="mr-5">
				<img className="h-1/2 w-[70px]" src={daysLeftImage} />
			</div>
			<div className="flex-1">
				<div className="mb-4">
					<h1 className="font-semibold text-xl">{headerText}</h1>
				</div>
				{bodyContent}
			</div>
		</div>
	</ModalWithChildren>
);
